import constate from "constate";
import { useCallback, useMemo, useState } from "react";
import { BP } from "utils/ui/breakpoints";

const MAX_FIXED_WIDTH_PX = BP.EIGHTY;

const calculateMaxWidth = () => {
  const maxWidth = document.body.clientWidth * 0.95;
  return Math.min(maxWidth, MAX_FIXED_WIDTH_PX);
};

const useObserver = () => {
  const [maxWidth, setMaxWidth] = useState(calculateMaxWidth());

  const calculateObserver = useCallback(() => {
    const observer = new ResizeObserver((mutations) => {
      if (mutations.at(0)?.target.clientWidth) {
        setMaxWidth(calculateMaxWidth());
      }
    });
    observer.observe(document.body);

    return () => {
      observer.disconnect();
    };
  }, []);

  const store = useMemo(() => {
    return {
      actions: { calculateObserver },
      state: {
        maxWidth,
      },
    };
  }, [maxWidth, calculateObserver]);

  return store;
};

export const [ObserverProvider, useObserverContext] = constate(useObserver);
